import { useMutation, useQueryClient } from '@tanstack/react-query';
import { pb } from '@/core/api';
import { useToast } from '@/components/ui/toast';

type Vars = { id: string; reason: string };

// Fase 28 (28.8.2): admin "gift" — clears has_used_redemption +
// redemption_passed_at so the user can attempt redemption again on a
// future ban. Does NOT change account_status; if the user is banned
// they stay banned, and the eligibility checks on the Game Over page
// will let them click "Intentar redención" again.
export function useResetRedemption() {
  const qc = useQueryClient();
  const { toast } = useToast();
  return useMutation({
    mutationFn: (v: Vars) =>
      pb.send(`/api/team-members/redemption/reset/${v.id}`, {
        method: 'POST',
        body: { reason: v.reason },
      }),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['team-members-admin'] });
      qc.invalidateQueries({ queryKey: ['approacher'] });
      toast('Redención reactivada', 'success');
    },
    onError: () => toast('Error al reactivar redención', 'error'),
  });
}
